import React from "react";
import Modal from "react-responsive-modal";
import { Button, Loader } from "@revvsales/components";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import UNFILLED_FORM_FILLED from "../../assets/unfilled-form-filled.gif";

const SubmitConfirmationPopup = ({
  onConfirm,
  onClose,
  isLoading,
  unfilledValue,
}) => (
  <Modal
    classNames={{
      modal: "sendconfirmationmodal",
    }}
    open
    onClose={onClose}
    center
    closeOnOverlayClick={false}>
    {isLoading && (
      <Loader
        className="loader-bg-color"
        label={` ${
          isLoading
            ? "🔏 Processing your document for eSignature."
            : "Loading..."
        }`}
      />
    )}
    <div className="send-confirmation-popup-wrapper">
      <div className="send-confirmation-body">
        <div className="send-confirmation-header">
          <FontAwesomeIcon
            className="emptysigner-popup-exclamation-icon"
            icon={["fas", "exclamation-triangle"]}
          />{" "}
          You have {unfilledValue || null} unfilled form fields
        </div>
        <div className="send-confirmation-body-wrapper">
          <div className="send-confirmation-body-info">
            This document contains unfilled form fields.
            <div
              style={{
                marginTop: "10px",
              }}>
              <div className="send-confirmation-body-list-item">
                <div className="send-confirmation-body-dot">&#8226;</div>
                <div className="send-confirmation-list-info">
                  If you missed filling them, go{" "}
                  <strong>back to document</strong> to fill them out. <br /> OR
                </div>
              </div>
              <div className="send-confirmation-body-list-item">
                <div className="send-confirmation-body-dot">&#8226;</div>
                <div className="send-confirmation-list-info">
                  If you left them out on purpose,{" "}
                  <strong>submit anyway</strong> to proceed to eSignature.
                </div>
              </div>
            </div>
          </div>
          <div className="send-confirmation-body-image-wrapper">
            <img
              src={UNFILLED_FORM_FILLED}
              alt="form-mode-check"
              className="send-confirmation-body-image"
            />
          </div>
        </div>
      </div>
      <div className="send-confirmation-footer">
        <Button
          data-test="back-to-document-button"
          className="send-confirmation-btn-inherit"
          onClick={onClose}
          onKeyPress={() => {}}>
          Back to document
        </Button>
        <Button
          data-test="submit-anyway-button"
          className="revv-btn-primary"
          onClick={onConfirm}
          onKeyPress={() => {}}>
          Submit anyway
        </Button>
      </div>
    </div>
  </Modal>
);
export default SubmitConfirmationPopup;



// WEBPACK FOOTER //
// ./src/components/DocumentApprovalPopupNew/SubmitConfirmationPopup.js